<script>
	export let currentYear = new Date().getFullYear().toString().substr(-4);
</script>

<main>
	<img id="logo" src="/logo.svg" alt="SOFTMILL logo" />

	<p>Creators of bespoke cloud-native data-driven enterprise software</p>
	<footer>Copyright &copy; {currentYear}, SoftMill Productions, Inc.</footer>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	p {
		color: #aaa;
		font-size: 0.9rem;
		font-weight: 100;
		line-height: 1.1;
		margin: 9rem auto;
		max-width: 70%;
	}

	footer {
		color: #444444;
		line-height: 1.35;
		font-size: 0.7rem;
	}

	#logo {
		margin-top: 6em;
		max-width: 80%;
	}

	@media (min-width: 480px) {
		#logo {
			max-width: 70%;
		}
	}

	@media only screen and (min-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
		#logo {
			max-width: 70%;
		}
	}

	@media (min-width: 540px) {
		#logo {
			max-width: 60%;
		}
	}

	@media only screen and (min-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
		#logo {
			max-width: 60%;
		}
	}

	@media (min-width: 600px) {
		#logo {
			max-width: 50%;
		}
	}

	@media only screen and (min-device-width: 600px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
		#logo {
			max-width: 50%;
		}
	}	
</style>
